import { makeAutoObservable, action, runInAction } from "mobx";
import apiHandler from "../handlers/ApiHandler";

class RegionStore {
  regions = [];
  managers = [];
  isLoading = false;
  error = null;

  constructor() {
    makeAutoObservable(this, {
      fetchRegions: action,
      fetchManagers: action,
      createRegion: action,
      updateRegion: action,
      deleteRegion: action,
    });
  }

  async fetchRegions() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiHandler.get("/api/regions");
      runInAction(() => {
        this.regions = response;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error fetching regions:", error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async fetchManagers() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await apiHandler.get("/api/regions/managers");
      runInAction(() => {
        this.managers = response;
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error fetching managers:", error);
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async createRegion(newRegion) {
    try {
      const response = await apiHandler.post("/api/regions", newRegion);
      runInAction(() => {
        this.regions.push(response);
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error("Error creating region:", error);
    }
  }

  async updateRegion(regionId, updatedData) {
    try {
      const response = await apiHandler.put(
        `/api/regions/${regionId}`,
        updatedData
      );
      runInAction(() => {
        const index = this.regions.findIndex(
          (region) => region.id === regionId
        );
        if (index !== -1) {
          this.regions[index] = response;
        }
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error updating region with ID ${regionId}:`, error);
    }
  }

  async deleteRegion(regionId) {
    try {
      await apiHandler.delete(`/api/regions/${regionId}`);
      runInAction(() => {
        this.regions = this.regions.filter((region) => region.id !== regionId);
      });
    } catch (error) {
      runInAction(() => {
        this.error = error.toString();
      });
      console.error(`Error deleting region with ID ${regionId}:`, error);
    }
  }

  get defaultRegionId() {
    const defaultRegion = this.regions.find(
      (r) => r.name.toLowerCase() === "default"
    );
    return defaultRegion?.id ?? 1;
  }
}

const regionStore = new RegionStore();
export default regionStore;
